import type { FullAuditedEntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';

export interface GetWhatsAppContactsInput extends PagedAndSortedResultRequestDto {
  filterText?: string;
  contato1?: string;
  contato2?: string;
  contato3?: string;
  contato4?: string;
  contato5?: string;
}

export interface WhatsAppContactCreateDto {
  contato1?: string;
  contato2?: string;
  contato3?: string;
  contato4?: string;
  contato5?: string;
}

export interface WhatsAppContactDto extends FullAuditedEntityDto<string> {
  contato1?: string;
  contato2?: string;
  contato3?: string;
  contato4?: string;
  contato5?: string;
  concurrencyStamp?: string;
}

export interface WhatsAppContactUpdateDto {
  contato1?: string;
  contato2?: string;
  contato3?: string;
  contato4?: string;
  contato5?: string;
  concurrencyStamp?: string;
}
